import Drawer from './src/drawer';

Drawer.install = function(Vue) {
  Vue.component(Drawer.name, Drawer);
};

export default Drawer;



// WEBPACK FOOTER //
// ./src/components/drawer/index.js